var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHabitIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7380_1386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.125 15H29.0625V12.1875H13.125V15ZM24.375 13.125H28.125V14.0625H24.375V13.125ZM14.0625 13.125H23.4375V14.0625H14.0625V13.125Z",
    fill: "url(#paint0_linear_7380_1386)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.375 16.4063H18.75C17.9698 16.4067 17.202 16.6019 16.5163 16.9741C15.8307 17.3464 15.2488 17.884 14.8235 18.5381C14.7024 18.318 14.5243 18.1345 14.308 18.0069C14.0916 17.8792 13.8449 17.8121 13.5937 17.8125H11.8494C11.5498 16.5624 11.0537 15.3678 10.3796 14.2732L10.1063 13.8292C9.0149 12.0562 8.43717 10.0151 8.4375 7.9331V3.39077C8.64978 3.201 8.79941 2.95122 8.86658 2.67452C8.93375 2.39782 8.9153 2.10724 8.81365 1.84126C8.71201 1.57528 8.53198 1.34645 8.29739 1.18506C8.06281 1.02367 7.78474 0.937341 7.5 0.9375H5.625C5.34026 0.937341 5.06219 1.02367 4.8276 1.18506C4.59302 1.34645 4.41299 1.57528 4.31135 1.84126C4.2097 2.10724 4.19125 2.39782 4.25842 2.67452C4.32559 2.95122 4.47522 3.201 4.6875 3.39077V7.9331C4.68783 10.0151 4.1101 12.0562 3.01867 13.8292L2.74538 14.2732C1.56301 16.1939 0.937134 18.4052 0.9375 20.6606V27.6563C0.937922 28.0291 1.08622 28.3865 1.34985 28.6502C1.61348 28.9138 1.97092 29.0621 2.34375 29.0625H12.8267C13.178 29.0641 13.5171 28.9334 13.7766 28.6965C14.036 28.4595 14.1968 28.1336 14.2271 27.7836L14.2948 27.0389C14.5347 27.6359 14.9476 28.1475 15.4805 28.5081C16.0133 28.8686 16.6418 29.0617 17.2852 29.0625H25.8398C26.6942 29.0615 27.5134 28.7217 28.1175 28.1175C28.7217 27.5134 29.0615 26.6943 29.0625 25.8398V25.3125H14.4517L14.5983 23.6997C14.6206 23.7214 14.6437 23.7443 14.6684 23.7689C14.9241 24.0247 15.2743 24.375 15.9372 24.375C16.6001 24.375 16.9503 24.0247 17.206 23.769C17.4358 23.5391 17.5485 23.4375 17.8119 23.4375C18.0754 23.4375 18.1881 23.5391 18.4179 23.769C18.6737 24.0247 19.024 24.375 19.6869 24.375C20.3498 24.375 20.7001 24.0247 20.9558 23.769C21.1856 23.5391 21.2984 23.4375 21.5619 23.4375C21.8254 23.4375 21.9381 23.5391 22.168 23.769C22.4237 24.0247 22.774 24.375 23.4369 24.375C24.0998 24.375 24.4501 24.0247 24.7059 23.769C24.9357 23.5391 25.0484 23.4375 25.3119 23.4375C25.5755 23.4375 25.6883 23.5391 25.9182 23.769C26.174 24.0248 26.5243 24.375 27.1872 24.375C27.8502 24.375 28.2005 24.0247 28.4563 23.769C28.6862 23.5391 28.7989 23.4375 29.0625 23.4375V22.5C28.3995 22.5 28.0492 22.8502 27.7935 23.106C27.5636 23.3359 27.4508 23.4375 27.1872 23.4375C26.9237 23.4375 26.8109 23.3359 26.581 23.106C26.3252 22.8503 25.9749 22.5 25.3119 22.5C24.649 22.5 24.2987 22.8503 24.0429 23.1061C23.8132 23.3359 23.7004 23.4375 23.4369 23.4375C23.1734 23.4375 23.0607 23.3359 22.8309 23.1061C22.5751 22.8503 22.2248 22.5 21.5619 22.5C20.899 22.5 20.5487 22.8503 20.2929 23.1061C20.0631 23.3359 19.9504 23.4375 19.6869 23.4375C19.4234 23.4375 19.3106 23.3359 19.0808 23.1061C18.8251 22.8503 18.4748 22.5 17.8119 22.5C17.149 22.5 16.7988 22.8503 16.5431 23.1061C16.3133 23.3359 16.2005 23.4375 15.9372 23.4375C15.6738 23.4375 15.5611 23.3359 15.3313 23.1061C15.173 22.9477 14.9782 22.7533 14.6957 22.6281L14.7926 21.5625H29.0625V21.0938C29.0611 19.851 28.5668 18.6595 27.688 17.7807C26.8092 16.902 25.6178 16.4077 24.375 16.4063ZM5.625 1.875H7.5C7.62432 1.875 7.74355 1.92439 7.83146 2.01229C7.91936 2.1002 7.96875 2.21943 7.96875 2.34375C7.96875 2.46807 7.91936 2.5873 7.83146 2.67521C7.74355 2.76311 7.62432 2.8125 7.5 2.8125H5.625C5.50068 2.8125 5.38145 2.76311 5.29354 2.67521C5.20564 2.5873 5.15625 2.46807 5.15625 2.34375C5.15625 2.21943 5.20564 2.1002 5.29354 2.01229C5.38145 1.92439 5.50068 1.875 5.625 1.875ZM2.34375 28.125C2.21947 28.1249 2.10033 28.0754 2.01245 27.9876C1.92457 27.8997 1.87514 27.7805 1.875 27.6563V20.6606C1.87467 18.5787 2.4524 16.5375 3.54384 14.7646L3.81712 14.3205C4.99949 12.3998 5.62537 10.1886 5.625 7.9331V3.75H7.5V7.9331C7.49964 10.1886 8.12551 12.3999 9.30788 14.3206L9.58117 14.7645C10.1637 15.7104 10.6024 16.7376 10.883 17.8125H8.14687C7.95147 17.8125 7.75821 17.8532 7.57942 17.9321C7.40063 18.0109 7.24024 18.1262 7.10847 18.2705C6.9767 18.4148 6.87645 18.5849 6.81411 18.7701C6.75177 18.9553 6.72871 19.1515 6.7464 19.3461L7.51344 27.7836C7.52437 27.9 7.54961 28.0147 7.58861 28.125H2.34375ZM13.2935 27.6987C13.2834 27.8154 13.2298 27.924 13.1433 28.003C13.0568 28.082 12.9438 28.1255 12.8267 28.125H8.91392C8.79679 28.1255 8.68376 28.082 8.59726 28.003C8.51077 27.924 8.45715 27.8154 8.44706 27.6987L7.89299 21.6039C8.07668 21.6607 8.20759 21.7727 8.37759 21.9184C8.67989 22.1775 9.05611 22.5 9.77634 22.5C10.4966 22.5 10.8729 22.1775 11.1752 21.9184C11.4252 21.7041 11.5904 21.5625 11.9639 21.5625C12.3374 21.5625 12.5026 21.7041 12.7527 21.9184C12.9963 22.1272 13.2882 22.3769 13.7691 22.4661L13.2935 27.6987ZM14.0605 19.2612L13.8548 21.5235C13.6671 21.4674 13.5351 21.3543 13.3628 21.2066C13.0605 20.9475 12.6842 20.625 11.9639 20.625C11.2436 20.625 10.8674 20.9475 10.5651 21.2066C10.315 21.4209 10.1498 21.5625 9.77634 21.5625C9.40292 21.5625 9.23779 21.4209 8.98779 21.2066C8.71738 20.9748 8.38702 20.6931 7.805 20.636L7.68002 19.2612C7.67413 19.1963 7.68182 19.131 7.7026 19.0692C7.72338 19.0075 7.7568 18.9508 7.80073 18.9027C7.84465 18.8546 7.89812 18.8162 7.95772 18.7899C8.01732 18.7636 8.08174 18.75 8.14687 18.75H13.5937C13.6588 18.75 13.7232 18.7636 13.7828 18.7899C13.8424 18.8162 13.8959 18.8546 13.9398 18.9027C13.9837 18.9508 14.0172 19.0075 14.0379 19.0692C14.0587 19.131 14.0664 19.1963 14.0605 19.2612ZM28.0882 26.25C27.9914 26.7759 27.7136 27.2514 27.3029 27.5939C26.8923 27.9364 26.3746 28.1243 25.8398 28.125H17.2852C16.7504 28.1243 16.2327 27.9364 15.8221 27.5939C15.4114 27.2514 15.1336 26.7759 15.0368 26.25H28.0882ZM15.0291 20.625C15.1445 19.7192 15.5859 18.8865 16.2707 18.2826C16.9555 17.6787 17.8369 17.3449 18.75 17.3438H24.375C25.2881 17.3449 26.1695 17.6787 26.8543 18.2826C27.5391 18.8865 27.9805 19.7192 28.0959 20.625H15.0291Z",
    fill: "url(#paint1_linear_7380_1386)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9062 11.25C24.9261 11.25 25.923 10.9476 26.7709 10.381C27.6188 9.81444 28.2797 9.00915 28.67 8.06696C29.0603 7.12478 29.1624 6.08803 28.9634 5.08782C28.7645 4.0876 28.2734 3.16885 27.5523 2.44773C26.8312 1.72662 25.9124 1.23553 24.9122 1.03658C23.912 0.837623 22.8752 0.939734 21.933 1.33C20.9909 1.72026 20.1856 2.38115 19.619 3.22909C19.0524 4.07703 18.75 5.07394 18.75 6.09375C18.7515 7.4608 19.2953 8.77142 20.2619 9.73807C21.2286 10.7047 22.5392 11.2485 23.9062 11.25ZM23.9062 1.875C24.7406 1.875 25.5563 2.12243 26.2501 2.58599C26.9438 3.04955 27.4846 3.70843 27.8039 4.47931C28.1232 5.25018 28.2067 6.09843 28.0439 6.91679C27.8812 7.73515 27.4794 8.48686 26.8894 9.07686C26.2994 9.66686 25.5476 10.0687 24.7293 10.2314C23.9109 10.3942 23.0627 10.3107 22.2918 9.99137C21.5209 9.67206 20.862 9.13133 20.3985 8.43756C19.9349 7.74379 19.6875 6.92814 19.6875 6.09375C19.6888 4.97526 20.1336 3.90294 20.9245 3.11204C21.7154 2.32115 22.7878 1.87627 23.9062 1.875Z",
    fill: "url(#paint2_linear_7380_1386)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8934 8.76889L23.9057 6.7566L25.918 8.76889L26.5809 8.10596L24.5686 6.09367L26.5809 4.08139L25.918 3.41846L23.9057 5.43074L21.8934 3.41846L21.2305 4.08139L23.2428 6.09367L21.2305 8.10596L21.8934 8.76889Z",
    fill: "url(#paint3_linear_7380_1386)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2188 18.2812H18.2812V19.2188H19.2188V18.2812Z",
    fill: "url(#paint4_linear_7380_1386)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0938 18.75H20.1562V19.6875H21.0938V18.75Z",
    fill: "url(#paint5_linear_7380_1386)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9688 18.2812H22.0312V19.2188H22.9688V18.2812Z",
    fill: "url(#paint6_linear_7380_1386)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8438 18.75H23.9062V19.6875H24.8438V18.75Z",
    fill: "url(#paint7_linear_7380_1386)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.64115 14.8683C3.44331 17.0276 2.81405 19.456 2.8125 21.9253V22.9689H3.75V21.9253C3.75145 19.6153 4.3401 17.3436 5.46066 15.3236L6.03476 14.2903L5.21524 13.835L4.64115 14.8683Z",
    fill: "url(#paint8_linear_7380_1386)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 23.9062H2.8125V24.8438H3.75V23.9062Z",
    fill: "url(#paint9_linear_7380_1386)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1875 10.3125C12.1882 9.69112 12.4354 9.09538 12.8747 8.656C13.3141 8.21661 13.9099 7.96946 14.5312 7.96875C14.9042 7.96875 15.2619 7.82059 15.5256 7.55687C15.7893 7.29315 15.9375 6.93546 15.9375 6.5625C15.9375 6.18954 15.7893 5.83185 15.5256 5.56813C15.2619 5.30441 14.9042 5.15625 14.5312 5.15625C13.9099 5.15554 13.3141 4.90839 12.8747 4.469C12.4354 4.02962 12.1882 3.43388 12.1875 2.8125V0.9375H11.25V2.8125C11.251 3.68244 11.597 4.51647 12.2121 5.13161C12.8273 5.74675 13.6613 6.09277 14.5312 6.09375C14.6556 6.09375 14.7748 6.14314 14.8627 6.23104C14.9506 6.31895 15 6.43818 15 6.5625C15 6.68682 14.9506 6.80605 14.8627 6.89396C14.7748 6.98186 14.6556 7.03125 14.5312 7.03125C13.6613 7.03223 12.8273 7.37825 12.2121 7.99339C11.597 8.60853 11.251 9.44256 11.25 10.3125V11.25H12.1875V10.3125Z",
    fill: "url(#paint10_linear_7380_1386)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5312 4.21875C15.1529 4.21875 15.749 4.46568 16.1885 4.90522C16.6281 5.34476 16.875 5.9409 16.875 6.5625C16.875 7.1841 16.6281 7.78024 16.1885 8.21978C15.749 8.65932 15.1529 8.90625 14.5312 8.90625C14.1584 8.90668 13.801 9.05497 13.5374 9.3186C13.2737 9.58223 13.1254 9.93967 13.125 10.3125V11.25H14.0625V10.3125C14.0626 10.1882 14.1121 10.0691 14.2 9.9812C14.2878 9.89332 14.407 9.84389 14.5312 9.84375C15.4015 9.84375 16.2361 9.49805 16.8514 8.88269C17.4668 8.26734 17.8125 7.43274 17.8125 6.5625C17.8125 5.69226 17.4668 4.85766 16.8514 4.24231C16.2361 3.62695 15.4015 3.28125 14.5312 3.28125C14.407 3.28111 14.2878 3.23168 14.2 3.1438C14.1121 3.05592 14.0626 2.93678 14.0625 2.8125V0.9375H13.125V2.8125C13.1254 3.18533 13.2737 3.54277 13.5374 3.8064C13.801 4.07003 14.1584 4.21832 14.5312 4.21875Z",
    fill: "url(#paint11_linear_7380_1386)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7380_1386",
    x1: 21.0938,
    y1: 12.1875,
    x2: 21.0938,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7380_1386",
    x1: 15,
    y1: 0.9375,
    x2: 15,
    y2: 29.0625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7380_1386",
    x1: 23.9063,
    y1: 0.9375,
    x2: 23.9063,
    y2: 11.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7380_1386",
    x1: 23.9057,
    y1: 3.41846,
    x2: 23.9057,
    y2: 8.76889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7380_1386",
    x1: 18.75,
    y1: 18.2812,
    x2: 18.75,
    y2: 19.2188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7380_1386",
    x1: 20.625,
    y1: 18.75,
    x2: 20.625,
    y2: 19.6875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7380_1386",
    x1: 22.5,
    y1: 18.2812,
    x2: 22.5,
    y2: 19.2188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_7380_1386",
    x1: 24.375,
    y1: 18.75,
    x2: 24.375,
    y2: 19.6875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_7380_1386",
    x1: 4.42363,
    y1: 13.835,
    x2: 4.42363,
    y2: 22.9689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_7380_1386",
    x1: 3.28125,
    y1: 23.9062,
    x2: 3.28125,
    y2: 24.8438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_7380_1386",
    x1: 13.5938,
    y1: 0.9375,
    x2: 13.5938,
    y2: 11.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_7380_1386",
    x1: 15.4688,
    y1: 0.9375,
    x2: 15.4688,
    y2: 11.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7380_1386"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHabitIcon);
export default __webpack_public_path__ + "static/media/habit-icon.5c825f64df506a3086d37d2740ea6129.svg";
export { ForwardRef as ReactComponent };